import { useRequest } from 'ahooks';

/**
 *
 * 对原有的useRequest做了一层业务封装
 * 内置了一个formatResult函数，对业务返回的response进行成功判定，如果成功则返回data，失败则触发useRequest的error
 * @param {Promise} servicer 请求函数
 * @param {Object} param1 useRequest配置项
 * @param  {...any} opts 其余useRequest的参数
 * @returns
 *
 * userRequest文档： https://ahooks-v2.surge.sh/zh-CN/hooks/async/#%E5%9F%BA%E7%A1%80-api
 */
export default function useOKRequest(servicer, { formatResult, manual, ...options } = {}, ...opts) {
  const { data, error, loading, run, runAsync, params, cancel, refresh, mutate, fetches } = useRequest(
    servicer,
    {
      // throwOnError: true,
      manual,
      throwOnError: true,
      ...options,
      formatResult(response) {
        const res = response.data;
        if (!res.success) throw new Error(`APIError: ${res.message}`);
        return formatResult?.(res.data) || res.data;
      },
    },
    ...opts,
  );
  return { data, error, loading, run, runAsync, params, cancel, refresh, mutate, fetches };
}

/* HOW TO USE */
// function UseOKRequestDemo() {
//   const { data, error, loading, run: getXXXList, params, cancel, refresh } = useOKRequest(api.getXXXList);
//   return (
//     <div>
//       <p>列表是否处于中：{loading}</p>
//       <p>请求数据：{JSON.stringify(params)}</p>
//       <p>响应数据：{JSON.stringify(data)}</p>
//       {!!error && <p>请求错误：{String(error)}</p>}
//       <Button onClick={getXXXList}>发起请求</Button>
//       <Button onClick={refresh}>刷新请求</Button>
//       <Button onClick={cancel}>取消请求</Button>
//     </div>
//   );
// }
